// KWANKGM03020_住宅ローンしっかり事前審査申込入力（確認）申込変更
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import FooterPreExaminationApplicationChangeConfirmationAppHousingLoanFirmly from '../../organisms/FooterPreExaminationApplicationChangeConfirmationAppHousingLoanFirmly';
import { KeyValue } from '../../types/KeyValue';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import FileUpload from '../../templates/FileUpload';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  is_loading: boolean;
  opened_mypage: boolean;
  moveNextStep: (step: number) => void;
  movePrevStep: () => void;
  guarantors_num: number;
  show_error_nav: boolean;
  display_status: boolean;
  has_debtor?: boolean;
  guarantor_info: GuarantorInfo;
  callApi: (function_name: string) => Promise<any>;
  requestModule: (module_name: string) => Promise<any>;
  handleClickTempSave: () => void; // 一時保存
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  loan_type: string;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
}

const PreExaminationChangeInputHousingLoanFirmlyConfirm: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  reception_id,
  status_code,
  is_loading,
  moveNextStep,
  movePrevStep,
  guarantors_num,
  show_error_nav,
  display_status,
  requestModule,
  callApi,
  guarantor_info,
  handleClickTempSave,
  has_debtor,
  shelf_info,
  setShelfInfo,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  loan_type,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      {/* 提出書類アコーディオン */}
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        loan_type={loan_type}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      {/* フッターボタン群 */}
      <FooterPreExaminationApplicationChangeConfirmationAppHousingLoanFirmly
        reception_id={reception_id}
        reception_cd={reception_cd}
        status_code={status_code}
        moveNextStep={moveNextStep}
        movePrevStep={movePrevStep}
        requestModule={requestModule}
        handleClickTempSave={handleClickTempSave}
        has_debtor={has_debtor}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default PreExaminationChangeInputHousingLoanFirmlyConfirm;
